import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const listAccountActivity = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { data } = await context.supabase
      .from("audit_log")
      .select("id, event, detail, ip, user_agent, created_at")
      .order("created_at", { ascending: false })
      .limit(50);
    return (data ?? []) as Array<{
      id: string;
      event: string;
      detail: string | null;
      ip: string | null;
      user_agent: string | null;
      created_at: string;
    }>;
  });

/** Called by the client right after a successful sign-in. */
export const recordSignIn = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) => z.object({ method: z.string().max(40) }).parse(d))
  .handler(async ({ context, data }) => {
    const { writeAudit } = await import("@/lib/audit.server");
    await writeAudit(context.userId, "sign_in", data.method, {}, getRequest());
    return { ok: true };
  });

/** Recorded before the client performs a global sign-out. */
export const recordSignOutAll = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { writeAudit } = await import("@/lib/audit.server");
    await writeAudit(context.userId, "sign_out_all", "Signed out of all devices", {}, getRequest());
    return { ok: true };
  });

export const recordSecurityEvent = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) =>
    z
      .object({
        event: z.enum(["mfa_enabled", "mfa_disabled", "retention_changed", "data_export"]),
        detail: z.string().max(200).optional(),
      })
      .parse(d),
  )
  .handler(async ({ context, data }) => {
    const { writeAudit } = await import("@/lib/audit.server");
    await writeAudit(context.userId, data.event, data.detail, {}, getRequest());
    return { ok: true };
  });